import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-step-indicator',
  standalone: true,
  templateUrl: './step-indicator.component.html',
  styleUrl: './step-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepIndicatorComponent implements OnChanges {
  @Input({ required: true }) totalSteps: number;
  @Input({ required: true }) currentStep: number;

  steps: number[] = [];

  ngOnChanges(): void {
    this.steps = Array.from({ length: this.totalSteps }, (_, i) => i);
  }

  isStepCompleted(stepIndex: number): boolean {
    return stepIndex < this.currentStep;
  }

  isStepCurrent(stepIndex: number): boolean {
    return stepIndex === this.currentStep;
  }

  isStepFuture(stepIndex: number): boolean {
    return stepIndex > this.currentStep;
  }
}
